import { render, staticRenderFns } from "./PainelInternacionalizacao.vue?vue&type=template&id=d325104a"
import script from "./PainelInternacionalizacao.vue?vue&type=script&lang=js"
export * from "./PainelInternacionalizacao.vue?vue&type=script&lang=js"
import style0 from "./PainelInternacionalizacao.vue?vue&type=style&index=0&id=d325104a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports